import { useState } from "react";
import Popup from "../Popup";
import {useDispatch, useSelector} from "react-redux";
import {useLazyEditJobDescriptionQuery} from "../../Store/Builder/jobs.api";
import {setLoader} from "../../Store/Slice/techsbookSlice";
import useGetJobs from "../../Global/Api/Jobs/getJobs.api";
import showToast from "../../Global/Hooks/toast";
import {useParams} from "react-router-dom";

export const EditJobDescription = ({close}) => {
    const {title: jobTitle} = useParams();
    const dispatch = useDispatch();
    const Jobs = useGetJobs({ allList: false });

    const [editJobDescription] = useLazyEditJobDescriptionQuery();

    const { activeJob } = useSelector((state) => state.rootReducer.jobsSlice);

    const [description, setDescription] = useState(activeJob?.description || '');

    const handleChange = (e) => {
        setDescription(e.target.value);
    }

    const handleSaveDesc = async () => {
        const body = {
            description: description
        };

        try {
            dispatch(setLoader(true));
            await editJobDescription({id: activeJob?.id, body}).unwrap();
            showToast('Job description successfully edited!', 'success');
            await Jobs.getById(jobTitle);
            dispatch(setLoader(false));
        } catch (e) {
            showToast(e?.data?.message, 'error');
            dispatch(setLoader(false));
        }

        close();
    };

    return (
        <Popup
            title="Edit Description"
            closePopup={close}
            contentStyles={{ width: '580px' }}
            headStyles={{ borderBottom: 'none' }}
        >
            <div className="edit-job-desc-modal">
                <div className="edit-job-desc-modal_body">
                    <textarea
                        value={description}
                        onChange={handleChange}
                    />
                </div>
                <div className="edit-job-desc-modal_foot">
                    <button className="edit-job-desc-modal_foot_cancel" onClick={close}>Cancel</button>
                    <button className="edit-job-desc-modal_foot_save" onClick={handleSaveDesc}>Save</button>
                </div>
            </div>
        </Popup>
    )
};